<template>
    <div v-if="isHomePage || isInscriptionsPage">
        <div class="content-container border-alert-inset">
            <div class="font-weight-600 text-h6">
                <v-icon icon="mdi-alert" color="primary-dark"></v-icon>
                Lien d'inscription de groupe
            </div>
            <div>
                Vous avez renseigné un lien d'inscription de groupe pour ce module (code :
                {{ mainStore.bookingSystem.groupe.token }}).
            </div>

        </div>

        <v-dialog v-model="displayDialog" width="600" max-width="95%" scroll-strategy="none">
            <v-card>
                <v-card-title class="font-weight-600">
                    <v-icon icon="mdi-account-group" color="primary-dark" class="mr-2"></v-icon>
                    Lien d'inscription de groupe détecté
                </v-card-title>
                <v-card-text class="text-justify">
                    <v-alert v-if="isBeforeOpeningBlocked" type="info" variant="tonal" density="comfortable"
                        class="mb-4 text-body-2">
                        Ce lien de groupe est valide, mais les inscriptions ne sont pas encore ouvertes. Vous pourrez
                        vous inscrire à partir de la date d'ouverture du module.
                    </v-alert>
                    <div class="d-flex flex-column gap-sm text-center">
                        <div>Je suis responsable du groupe, je veux inscrire un ou plusieurs participants</div>
                        <SportipsButton class="my-2" @click="onAcknowledgeGroup" chevron
                            icon="mdi-account-multiple-plus" :disabled="isBeforeOpeningBlocked">
                            J'inscris mon
                            groupe
                        </SportipsButton>
                        <div class="font-weight-bold text-primary-dark my-2 text-h6">Ou</div>
                        <div>Mon responsable m'a invité à m'inscrire à ce groupe</div>
                        <SportipsButton class="my-2" @click="onAcknowledge" chevron icon="mdi-account-plus"
                            :disabled="isBeforeOpeningBlocked">Je m'inscris
                        </SportipsButton>
                    </div>
                    <v-divider class="my-2"></v-divider>


                    <ConfigLienGroupeTable :groupe="mainStore.bookingSystem.groupe" />
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-btn variant="text" color="darkblue" @click="onLeaveGroup"><v-icon icon="mdi-close"
                            class="mr-2"></v-icon> Quitter
                        le
                        groupe</v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";

import ConfigLienGroupeTable from "@/components/App/Header/ConfigLienGroupeTable.vue";

export default {
    components: { ConfigLienGroupeTable },
    data() {
        return {
            displayDialog: false,
        };
    },
    computed: {
        ...mapStores(useMainStore),
        isHomePage() {
            return this.$route.name === 'Home';
        },
        isInscriptionsPage() {
            return this.$route.name === 'Inscriptions';
        },
        isBeforeOpeningBlocked() {
            return this.mainStore.module.status === 'avant_ouverture'
                && !this.mainStore.bookingSystem.groupe.allow_before_opening;
        },
    },
    watch: {
        "mainStore.bookingSystem.groupe.token": {
            immediate: true,
            handler(token) {
                if (token && this.isHomePage) {
                    this.displayDialog = true;
                }
            },
        },
        isHomePage: {
            immediate: true,
            handler(isHome) {
                if (!isHome) {
                    this.displayDialog = false;
                } else if (this.mainStore.bookingSystem.groupe.token) {
                    this.displayDialog = true;
                }
            },
        },
    },
    methods: {
        onAcknowledge() {
            this.displayDialog = false;
        },
        onAcknowledgeGroup() {
            this.displayDialog = false;
            this.mainStore.bookingSystem.groupe.is_inscription_groupe = true;
            this.mainStore.bookingSystem.init();
            this.$router.push({ name: "Inscriptions" });
        },
        onLeaveGroup() {
            this.mainStore.bookingSystem.groupe.clearState();
            this.mainStore.bookingSystem.groupe.clearLocalStorage();
        },
    },

};
</script>

<style lang="scss" scoped></style>